export const IL_ENVIRONMENT = {
  PRODUCTION: 'Production',
  STAGE: 'Staging'
}
